/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-02 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Icon, FormLayout, Link, Stack, TextStyle } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import { Field } from 'redux-form';
import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import history from 'src/routes/history';
import { routes } from 'src/routes';

import { ELEMENTS } from 'src/constants/theme-settings';
import { PRODUCT_RATING_ALIGNMENT_OPTIONS } from 'src/constants/theme-settings.jsx';
import { PRODUCT_REVIEWS } from 'src/constants/integration';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  prefix: string,
  currentAppReviewIntegration: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductRatingForm extends Component<ComposedProps> {
  render() {
    const { i18n, prefix, currentAppReviewIntegration } = this.props;
    const appRating = PRODUCT_REVIEWS.find(item => item.appName === currentAppReviewIntegration);

    return (
      <FormLayout>
        {appRating && (
          <div>
            <span className="form-link">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.ThemeSetting.Form.productRating_UserGuide')}
              </TextStyle>{' '}
              <Link url={URL['ProductRatingThemeSetting']} external>
                {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
                <Icon source={ExternalMinor} color="base" />
              </Link>
              <span style={{ color: '#2C6ECB' }}>.</span>
            </span>
          </div>
        )}

        <div className="form-section">
          <div className="form-section__item">
            <div className="form-title">
              <span style={{ marginRight: '6px' }}>
                {i18n.translate('AdminHTML.ThemeSetting.Form.productRating_InstalledApp')}
              </span>
            </div>
            {appRating ? (
              <div style={{ marginTop: '8px' }}>
                <Stack alignment="center" spacing="tight">
                  <div className="icon-app-rating">
                    <img src={appRating.smallIcon} alt="icon" />
                  </div>
                  <p>{i18n.translate(appRating.name)}</p>
                </Stack>
              </div>
            ) : (
              <div style={{ marginTop: '8px', color: '#6D7175' }}>
                <span>{i18n.translate('AdminHTML.ThemeSetting.Form.productRating_Guide1')}</span>{' '}
                <span className="form-link">
                  <Link
                    removeUnderline
                    onClick={() => {
                      history.push(routes.integration.view());
                    }}>
                    <span style={{ textDecoration: 'underline' }}>
                      {i18n.translate('AdminHTML.ThemeSetting.Form.productRating_Guide2')}
                    </span>
                    <Icon source={ExternalMinor} color="base" />
                    <span style={{ color: '#2C6ECB' }}>.</span>
                  </Link>
                </span>
              </div>
            )}
          </div>

          {prefix !== ELEMENTS.PRODUCT_INFORMATION_RATING && (
            <div className="form-section__item form-section__item--medium-spacing">
              <p className="title">
                {i18n.translate('AdminHTML.ThemeSetting.Form.productRating_Alignment_Item')}
              </p>
              <div className="radio-button-wrapper">
                {PRODUCT_RATING_ALIGNMENT_OPTIONS.map((item, index) => (
                  <Field
                    key={index}
                    name={`${prefix}.alignment`}
                    id={item.value}
                    component={RenderRadioButton2}
                    label={item.icon}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductRatingForm);
